export default class Scadenza{

    CodiceCliente;
    DataDocumento;
    DataScadenza;
    NumeroDocumento;
    NumeroRata;
    TotaleDocumento;
    ImportoRata;
    Tipo;

    constructor(){}

}